

































import { Vue, Component, Prop } from "vue-property-decorator";
import MD5 from "crypto-js/md5";

@Component
export default class Avatar extends Vue {
  // Props

  @Prop({ default: null })
  public src!: string;

  @Prop({ default: null })
  public name!: string;

  @Prop({ default: "" })
  public email!: string;

  @Prop({ default: 100 })
  public size!: number;

  // Data

  public hasImage = false;

  // Computed

  public get initials() {
    const name = (this.name || "").trim().split(" ");
    if (name.length > 1) {
      const first = this.$_.first(this.$_.first(name)) || "";
      const last = this.$_.first(this.$_.last(name)) || "";
      return `${first + last}`.toUpperCase();
    }
    return name[0].substring(0, 2).toUpperCase();
  }

  public get gravatarSrc() {
    const hash = MD5(this.email).toString();
    return `https://gravatar.com/avatar/${hash}?d=404&s=200`;
  }

  // Methods

  public handleImgError($event: Event) {
    const picture = ($event.target as Element).parentElement;
    picture?.setAttribute("data-initials", this.initials);
  }

  public handleLoadEvent() {
    this.hasImage = true;
  }
}
